import { HttpMethod } from "@/lib/utils/http-methods";
import { Store } from "@/stores/common/store.core";
import type {
   CreateEquipmentRequestPayload,
   CreateEquipmentRequestResponse,
} from "@laborchart-modules/lc-core-api/dist/api/equipment-request/create-equipment-request";
import type { DeleteEquipmentRequestResponse } from "@laborchart-modules/lc-core-api/dist/api/equipment-request/delete-equipment-request";
import type { GetEquipmentRequestResponse } from "@laborchart-modules/lc-core-api/dist/api/equipment-request/get-equipment-request";
import type {
   UpdateEquipmentRequestPayload,
   UpdateEquipmentRequestResponse,
} from "@laborchart-modules/lc-core-api/dist/api/equipment-request/update-equipment-request";
import type {
   FillEquipmentRequestPayload,
   FillEquipmentRequestResponse,
} from "@laborchart-modules/lc-core-api/dist/api/requests/fill-equipment-request";
import type { StoreJsonResponse } from "./common";

export abstract class EquipmentRequestStore extends Store {
   private static readonly basePath = "/api/v3/equipment-requests";

   static createEquipmentRequest(
      body: CreateEquipmentRequestPayload & { quantity?: number },
   ): StoreJsonResponse<CreateEquipmentRequestResponse> {
      return this.requestJson({
         method: HttpMethod.POST,
         url: this.basePath,
         body,
      });
   }

   static getEquipmentRequest(id: string): StoreJsonResponse<GetEquipmentRequestResponse> {
      return this.requestJson({
         method: HttpMethod.GET,
         url: `${this.basePath}/${id}`,
      });
   }

   static updateEquipmentRequest(
      id: string,
      body: UpdateEquipmentRequestPayload,
   ): StoreJsonResponse<UpdateEquipmentRequestResponse> {
      return this.requestJson({
         method: HttpMethod.PATCH,
         url: `${this.basePath}/${id}`,
         body,
      });
   }

   static deleteEquipmentRequest(id: string): StoreJsonResponse<DeleteEquipmentRequestResponse> {
      return this.requestJson({
         method: HttpMethod.DELETE,
         url: `${this.basePath}/${id}`,
      });
   }

   static fillEquipmentRequest(
      requestId: string,
      payload: FillEquipmentRequestPayload,
   ): StoreJsonResponse<FillEquipmentRequestResponse> {
      return this.requestJson({
         url: `${this.basePath}/${requestId}/fill`,
         method: HttpMethod.POST,
         body: payload,
      });
   }
}
